import { Reveal, Eyebrow } from "@/components/site/Motion";

export const About = () => (
  <section data-testid="about-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-36 lg:px-12">
    <div className="grid items-center gap-14 lg:grid-cols-12">
      <Reveal className="relative lg:col-span-6">
        <div className="aspect-[4/5] overflow-hidden rounded-t-[999px]">
          <img src="/img/real-treinador.jpg" alt="Francisco Silva, treinador DOG'Z" className="h-full w-full object-cover object-top" />
        </div>
        <div className="absolute -bottom-10 right-0 hidden w-[46%] overflow-hidden border-[10px] border-[#08090B] sm:block">
          <img src="/img/real-certificados.jpg" alt="Alunos DOG'Z com certificado" className="aspect-square w-full object-cover" />
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5 lg:col-start-8">
        <Eyebrow>Quem somos</Eyebrow>
        <h2 className="mt-6 font-display text-5xl font-semibold uppercase leading-[0.9] tracking-tight sm:text-7xl">
          Uma paixão com <span className="font-serif font-normal normal-case italic tracking-normal text-[#C8D484]">nome próprio.</span>
        </h2>
        <p className="mt-8 text-white/80">
          A DOG'Z nasceu do sonho de Francisco Silva, treinador de cães que cresceu rodeado deles. O nome é uma homenagem à Zoe, a sua cadela. Foi com ela que o Francisco começou no mundo dos cães, na busca e salvamento.
        </p>
        <p className="mt-4 text-white/70">
          Hoje oferecemos treinos adaptados às necessidades de cada cão, com um objetivo simples: melhorar a comunicação e a relação entre o cão e a sua família.
        </p>
        <p className="mt-10 font-serif text-2xl italic text-white/90">— Francisco Silva, fundador</p>
      </Reveal>
    </div>
  </section>
);
